<div class="grid col-12">

  @if (!userReady) {
    <div class="col-12">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (messages.length > 0) {
    <div class="col-12">
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="asMessageSeverity(m.severity)"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }
  @if (!fromNewCompanyLayoutButton && !fromCompanyAssociationLayoutButton) {
    <div class="col-12">
      <p-accordion [multiple]="true" [value]="['newCompany', 'companyAssoc']">
        @if (isUserGlobalAdmin()) {
          <p-accordion-panel value="newCompany">
            <p-accordion-header>New Company Requests</p-accordion-header>
            <p-accordion-content>
              <app-new-company-request [user]="user" (error)="displayErrors($event)"></app-new-company-request>
            </p-accordion-content>
          </p-accordion-panel>
        }
        <p-accordion-panel value="companyAssoc">
          <p-accordion-header>Company Association Requests</p-accordion-header>
          <p-accordion-content>
            <app-company-association-request [user]="user" (error)="displayErrors($event)"></app-company-association-request>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
  }
  @if (fromNewCompanyLayoutButton) {
    <div class="col-12">
      <app-new-company-request [user]="user" (error)="displayErrors($event)" [dialogOnly]="fromNewCompanyLayoutButton"></app-new-company-request>
    </div>
  }
  @if (fromCompanyAssociationLayoutButton) {
    <div class="col-12">
      <app-company-association-request [user]="user" (error)="displayErrors($event)" [dialogOnly]="fromCompanyAssociationLayoutButton"></app-company-association-request>
    </div>
  }
</div>
